module.exports = __webpack_public_path__ + "static/media/0021_IMG_LES_MURS_BARDAGE_BOIS_HORIZONTAL.e5597baa.png";